import React, { useEffect } from 'react'
import { useTranslation } from 'next-i18next'
import { UseFormReturn } from 'react-hook-form'
import CheckboxField from 'modules/ui/molecules/FormComponents/CheckboxField'
import DonationOptionFormWrapper from './donation-option-form-wrapper'
import { object, boolean } from 'yup'
import useOrder from 'modules/order/state/order/use-order'

export type HideAmountFormData = {
  isAmountAnonymous: boolean
}

const HideAmountOptionFields = ({ form }: { form: UseFormReturn<HideAmountFormData> }) => {
  const { t } = useTranslation()
  const order = useOrder()

  const {
    watch,
    formState: { errors },
  } = form

  const isAmountAnonymous = watch('isAmountAnonymous')

  useEffect(() => {
    order.contact.updateField('isAmountAnonymous', isAmountAnonymous)
  }, [isAmountAnonymous, order.contact])

  return (
    <CheckboxField
      id="isAmountAnonymous"
      dataId="donor-privacy-hide-amount-checkbox"
      error={
        errors.isAmountAnonymous
          ? { message: errors.isAmountAnonymous.message || 'Invalid value' }
          : undefined
      }
    >
      {t('OrderAnonymousFields.hideDonation.alternateLabel', 'Hide my amount')}
    </CheckboxField>
  )
}

const HideAmountOption = () => {
  const validationSchema = object({
    isAmountAnonymous: boolean().required(),
  })

  const useHideAmountValues = (): HideAmountFormData => {
    const order = useOrder()

    return {
      isAmountAnonymous: order.contact.value.isAmountAnonymous,
    }
  }

  return (
    <DonationOptionFormWrapper<HideAmountFormData>
      formName="hideAmount"
      errorMessage="Please review your hide amount option"
      validationSchema={validationSchema}
      useInitialValues={useHideAmountValues}
    >
      {(form) => <HideAmountOptionFields form={form} />}
    </DonationOptionFormWrapper>
  )
}

export default HideAmountOption
